/**
 * Текущий режим темы, доступный любому компоненту.
 *
 * Токены antd отвечают на вопрос «какой цвет», но не на вопрос «светло сейчас или
 * темно», а он нужен там, где цвет выбирает не наш код: графики G2 несут собственные
 * темы целиком (`classic` / `classicDark`), и собрать их из отдельных токенов нельзя.
 *
 * Выводить режим из значения токена (сравнить яркость фона) было бы догадкой о чужой
 * реализации: та же тема с другим `colorBgContainer` сломала бы вывод молча. Режим
 * известен точно — его задаёт платформа в `HostContext.theme`, — поэтому он просто
 * передаётся вниз.
 *
 * Провайдер здесь не заводится компонентом намеренно: файл с хуками и компонентом
 * одновременно ломает fast refresh, а единственное место, где провайдер нужен, — это
 * `App.tsx`, где рядом и выбирается тема.
 */

import { createContext, useContext } from 'react';
import { STANDALONE_THEME_MODE, type ThemeMode } from './appTheme';

export const ThemeModeContext = createContext<ThemeMode>(STANDALONE_THEME_MODE);

/**
 * Режим активной темы.
 *
 * Значение по умолчанию — режим standalone, а не бросок исключения: компонент может
 * рендериться в тесте без провайдера, и падение там сообщало бы о проблеме теста, а
 * не кода. Ошибиться значение не даёт: провайдер стоит в единственном месте, где
 * тема вообще выбирается.
 */
export function useThemeMode(): ThemeMode {
  return useContext(ThemeModeContext);
}

/** Тема графиков G2 под текущий режим — у них своя пара тем, а не набор токенов. */
export function useChartTheme(): 'classic' | 'classicDark' {
  return useThemeMode() === 'dark' ? 'classicDark' : 'classic';
}
